import { render, staticRenderFns } from "./font-style-selector.vue?vue&type=template&id=1b023d28&"
import script from "./font-style-selector.vue?vue&type=script&lang=js&"
export * from "./font-style-selector.vue?vue&type=script&lang=js&"
import style0 from "./font-style-selector.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports